export default Object.freeze({
  CurrentIpReport: 1,
  DetailIpReport: 2,
  AttachmentIpReport: 3,
  HearingCaseReport: 4,
  GlobalBillingPeriodReport: 6,
  GlobalBillingPeriodReportPdf: 7,
  InformeInformacionSolicitudesExcel: 8,
  InformeInformacionSolicitudesPdf: 9,
  BillingSubmittedPeriodReportExcel: 10,
  BillingSubmittedPeriodReportPdf: 11,
  RequestsContractsReportExcel:12,
  RequestsContractsReportPDF:13,
  ReportReferralDocumentTrackingExcel: 14,
  AnalysisAlternativeLocationRegionalOffice: 15,
  InformeDefinePEIPreguntasAdicionalesExcel: 16,
  InformeEstipulacion49SanJuanBitacoraExcel: 17,
  InformeEstipulacion49SanJuanDetalleExcel: 18,
  Indicador13EvaluacionDeServiciosDeTransicionExcel: 19,
  InternTraineeAgreements: 20,
});
